import {authenticationService} from './services/AuthenticationService'
import router from './router'
/**
 * This code will check if the page is secure and redirect the user to the login page if the user have not logged-in
 */
router.beforeEach((to, from, next) => {
  console.log('router: ' + to.path + ' secure=' + to.meta.secure)
  if (to.meta.secure) {
    // console.log('router: page is secure, checking if user has authenticated')
    if (authenticationService.isAuthenticated() === false) {
      // console.log('router: User has not authenticated, redirecting to login page at /login')
      next('/login')
      return
    }
  }
  next()
})



// WEBPACK FOOTER //
// ./src/route-security.js